import { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import { TabFinanceiro } from '../components/perfil/TabFinanceiro';
import { TabInternacao } from '../components/perfil/TabInternacao';
import { HistoricoProntuarios } from '../components/perfil/HistoricoProntuarios';
import { TabPlanejamento } from '../components/perfil/TabPlanejamento';
import { TabTarefas } from '../components/perfil/TabTarefas';
import { TabConsumo } from '../components/perfil/TabConsumo';
import { TabComodato } from '../components/perfil/TabComodato';
import { TabServicos } from '../components/perfil/TabServicos';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Textarea } from '../components/ui/textarea';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../components/ui/alert-dialog';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../components/ui/dialog';
import { 
  ArrowLeft, 
  Save, 
  Loader2, 
  Calendar, 
  Clock,
  ClipboardList,
  AlertTriangle,
  LogOut,
  Pencil,
  X,
  Package,
  Briefcase,
  Stethoscope,
  DollarSign,
  RotateCcw,
  PackageCheck,
  CircleCheck,
  Circle
} from 'lucide-react';
import { toast } from 'sonner';
import { 
  formatDate, 
  getDaysAlertLevel, 
  STATUS_LABELS, 
  STATUS_COLORS,
  ALTA_MOTIVO_LABELS,
  ORIGEM_LABELS,
  formatOrigem,
  getOrigemColor,
  todayLocal,
  displayCPF
} from '../lib/utils';

const PerfilInternacao = () => {
  const { api, user, isAdmin, canEditPatient, canViewFullCPF, canViewServiceRevenue, canViewServicePayout, canViewStockCosts } = useAuth();
  const navigate = useNavigate();
  const { pacienteId, internacaoId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [paciente, setPaciente] = useState(null);
  const [internacao, setInternacao] = useState(null);
  const [planejamento, setPlanejamento] = useState(null);
  const [tarefas, setTarefas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [medicos, setMedicos] = useState([]);
  const [historicoEquipe, setHistoricoEquipe] = useState([]);
  const [historicoMedico, setHistoricoMedico] = useState([]);
  
  // Edit mode states
  const [isEditing, setIsEditing] = useState(false);
  const [editPaciente, setEditPaciente] = useState(null);
  const [editInternacao, setEditInternacao] = useState(null);
  
  // Modal states
  const [tarefaModalOpen, setTarefaModalOpen] = useState(false);
  const [altaModalOpen, setAltaModalOpen] = useState(false);
  const [tarefaFilter, setTarefaFilter] = useState('todas'); // 'todas' | 'hoje' | 'vencidas'
  const [activeTab, setActiveTab] = useState('internacao'); // Tab state
  
  // Financial data state
  const [financeiroData, setFinanceiroData] = useState(null);
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  
  const [novaTarefa, setNovaTarefa] = useState({
    titulo: '',
    tipo: 'visita',
    data_prevista: todayLocal(),
    responsavel_id: '',
    prioridade: 'media',
    status: 'a_fazer',
    observacoes: '',
    recorrente: false,
    recorrencia_dias: 1,
    data_fim: '',
    num_ocorrencias: ''
  });
  const [altaData, setAltaData] = useState({
    data_alta: todayLocal(),
    motivo_alta: 'alta_clinica',
    comentario_alta_administrativa: ''
  });
  const [showReversaoAlta, setShowReversaoAlta] = useState(false);
  const [reversaoJustificativa, setReversaoJustificativa] = useState('');
  const [savingReversao, setSavingReversao] = useState(false);
  // Comodato collection on discharge
  const [altaStep, setAltaStep] = useState('form'); // 'form' | 'comodato'
  const [comodatoRecolhidos, setComodatoRecolhidos] = useState({});
  
  // Consumo states
  const [consumoRegras, setConsumoRegras] = useState([]);
  const [estoqueItens, setEstoqueItens] = useState([]);
  const [showConsumoModal, setShowConsumoModal] = useState(false);
  const [editingConsumo, setEditingConsumo] = useState(null);
  const [consumoForm, setConsumoForm] = useState({
    item_id: '',
    frequencia: '1x ao dia',
    quantidade_por_aplicacao: '1',
    data_inicio: todayLocal(),
    data_fim: '',
    observacoes: '',
    tipo_uso: 'programado'
  });

  // Comodato states
  const [comodatoAlocacoes, setComodatoAlocacoes] = useState([]);
  const [comodatoItens, setComodatoItens] = useState([]);
  const [showComodatoModal, setShowComodatoModal] = useState(false);
  const [comodatoForm, setComodatoForm] = useState({ comodato_item_id: '', quantidade_em_uso: 1, observacoes: '' });

  // Serviços states
  const [servicosPaciente, setServicosPaciente] = useState([]);
  const [servicosCatalogo, setServicosCatalogo] = useState([]);
  const [showServicoModal, setShowServicoModal] = useState(false);
  const [editingServico, setEditingServico] = useState(null);
  const [servicoForm, setServicoForm] = useState({
    servico_id: '',
    profissional: '',
    recorrente: true,
    frequencia_dias: 1,
    quantidade_por_ocorrencia: 1,
    data_inicio: todayLocal(),
    data_realizacao: todayLocal(),
    data_fim: '',
    observacoes: ''
  });
  
  // Resumo de custos states
  const [resumoCustos, setResumoCustos] = useState(null);
  const [resumoPeriodo, setResumoPeriodo] = useState(30);
  const [loadingResumo, setLoadingResumo] = useState(false);

  // Prescrição IA states
  const [showPrescricaoModal, setShowPrescricaoModal] = useState(false);
  const [prescricaoLoading, setPrescricaoLoading] = useState(false);
  const [prescricaoFile, setPrescricaoFile] = useState(null);
  const [prescricaoResult, setPrescricaoResult] = useState(null);
  const [selectedPrescricaoItens, setSelectedPrescricaoItens] = useState([]);

  useEffect(() => {
    fetchData();
  }, [pacienteId, internacaoId]);
  
  // Check for edit mode from URL params
  useEffect(() => {
    if (searchParams.get('edit') === 'true' && paciente && internacao) {
      setIsEditing(true);
      setEditPaciente({ ...paciente });
      setEditInternacao({ ...internacao });
    }
  }, [searchParams, paciente, internacao]);

  const fetchData = async () => {
    try {
      const [pacRes, intRes, planRes, tarefasRes, usuariosRes, consumoRes, estoqueRes, servicosPacRes, servicosCatRes, comodatoResumoRes, comodatoItensRes, medicosRes, histEqRes, histMedRes] = await Promise.all([
        api.get(`/pacientes/${pacienteId}`),
        api.get(`/internacoes/${internacaoId}`),
        api.get(`/planejamentos/${internacaoId}`).catch(() => ({ data: null })),
        api.get(`/tarefas?internacao_id=${internacaoId}`).catch(() => ({ data: [] })),
        api.get('/usuarios/resumo').catch(() => ({ data: [] })),
        api.get(`/estoque/consumo/regras?internacao_id=${internacaoId}`).catch(() => ({ data: [] })),
        api.get('/estoque/itens').catch(() => ({ data: [] })),
        api.get(`/servicos/paciente/${internacaoId}`).catch(() => ({ data: [] })),
        api.get('/servicos/catalogo?apenas_ativos=true').catch(() => ({ data: [] })),
        api.get(`/comodato/internacao/${internacaoId}/resumo`).catch(() => ({ data: { alocacoes: [] } })),
        api.get('/comodato/itens?ativo=true').catch(() => ({ data: [] })),
        api.get('/medicos').catch(() => ({ data: [] })),
        api.get(`/internacoes/${internacaoId}/historico-equipe`).catch(() => ({ data: [] })),
        api.get(`/internacoes/${internacaoId}/historico-medico`).catch(() => ({ data: [] }))
      ]);
      
      setPaciente(pacRes.data);
      setInternacao(intRes.data);
      setPlanejamento(planRes.data);
      setTarefas(tarefasRes.data);
      setUsuarios(usuariosRes.data);
      setConsumoRegras(consumoRes.data || []);
      setEstoqueItens(estoqueRes.data || []);
      setServicosPaciente(servicosPacRes.data || []);
      setServicosCatalogo(servicosCatRes.data || []);
      setComodatoAlocacoes(comodatoResumoRes.data?.alocacoes || []);
      setComodatoItens(comodatoItensRes.data || []);
      setMedicos(medicosRes.data || []);
      setHistoricoEquipe(histEqRes.data || []);
      setHistoricoMedico(histMedRes.data || []);
      
      // Fetch resumo de custos
      fetchResumoCustos(internacaoId, resumoPeriodo);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };
  
  const fetchResumoCustos = async (intId, dias) => {
    if (!intId) return;
    setLoadingResumo(true);
    try {
      const response = await api.get(`/servicos/resumo-custos/${intId}?periodo_dias=${dias}`);
      setResumoCustos(response.data);
    } catch (error) {
      console.error('Error fetching resumo custos:', error);
    } finally {
      setLoadingResumo(false);
    }
  };
  
  // Fetch financial data for the Financeiro tab
  const fetchFinanceiroData = async () => {
    if (!internacaoId) return;
    setLoadingFinanceiro(true);
    try {
      const response = await api.get(`/financeiro/paciente/${internacaoId}`);
      setFinanceiroData(response.data);
    } catch (error) {
      console.error('Error fetching financial data:', error);
      toast.error('Erro ao carregar dados financeiros');
    } finally {
      setLoadingFinanceiro(false);
    }
  };
  
  // Load financial data when tab changes to "financeiro"
  useEffect(() => {
    if (activeTab === 'financeiro' && !financeiroData) {
      fetchFinanceiroData();
    }
  }, [activeTab, financeiroData]);
  
  // Update resumo when period changes
  useEffect(() => {
    if (internacaoId) {
      fetchResumoCustos(internacaoId, resumoPeriodo);
    }
  }, [resumoPeriodo, internacaoId]);

  const handleSavePlanejamento = async () => {
    setSaving(true);
    try {
      await api.put(`/planejamentos/${internacaoId}`, {
        ...planejamento,
        internacao_id: internacaoId
      });
      toast.success('Planejamento salvo!');
    } catch (error) {
      toast.error('Erro ao salvar planejamento');
    } finally {
      setSaving(false);
    }
  };

  const handleCreateTarefa = async () => {
    try {
      if (novaTarefa.recorrente) {
        // Create recurring task
        const response = await api.post('/tarefas/recorrente', {
          internacao_id: internacaoId,
          titulo: novaTarefa.titulo,
          tipo: novaTarefa.tipo,
          prioridade: novaTarefa.prioridade,
          observacoes: novaTarefa.observacoes,
          recorrencia_dias: parseInt(novaTarefa.recorrencia_dias) || 1,
          data_inicio: novaTarefa.data_prevista,
          data_fim: novaTarefa.data_fim || null,
          num_ocorrencias: novaTarefa.num_ocorrencias ? parseInt(novaTarefa.num_ocorrencias) : null
        });
        toast.success(`${response.data.total_ocorrencias} tarefa(s) recorrente(s) criada(s)!`);
        fetchData(); // Refresh to get new tasks
      } else {
        // Create single task
        const response = await api.post('/tarefas', {
          ...novaTarefa,
          internacao_id: internacaoId
        });
        setTarefas([...tarefas, response.data]);
        toast.success('Tarefa criada!');
      }
      
      setTarefaModalOpen(false);
      setNovaTarefa({
        titulo: '',
        tipo: 'visita',
        data_prevista: todayLocal(),
        responsavel_id: '',
        prioridade: 'media',
        status: 'a_fazer',
        observacoes: '',
        recorrente: false,
        recorrencia_dias: 1,
        data_fim: '',
        num_ocorrencias: ''
      });
    } catch (error) {
      toast.error('Erro ao criar tarefa');
      console.error('Error creating task:', error);
    }
  };

  const handleUpdateTarefaStatus = async (tarefaId, newStatus) => {
    try {
      const tarefa = tarefas.find(t => t.id === tarefaId);
      await api.put(`/tarefas/${tarefaId}`, {
        ...tarefa,
        status: newStatus
      });
      setTarefas(tarefas.map(t => 
        t.id === tarefaId ? { ...t, status: newStatus } : t
      ));
      toast.success('Status atualizado!');
    } catch (error) {
      toast.error('Erro ao atualizar tarefa');
    }
  };

  const handleDeleteTarefa = async (tarefaId) => {
    try {
      await api.delete(`/tarefas/${tarefaId}`);
      setTarefas(tarefas.filter(t => t.id !== tarefaId));
      toast.success('Tarefa removida!');
    } catch (error) {
      toast.error('Erro ao remover tarefa');
    }
  };

  const activeComodatos = comodatoAlocacoes.filter(a => a.status === 'ativo');
  const allComodatosRecolhidos = activeComodatos.length === 0 || activeComodatos.every(a => comodatoRecolhidos[a.id]);

  const handleAltaNext = () => {
    // Validate form step first
    if (altaData.motivo_alta === 'alta_administrativa') {
      if (!altaData.comentario_alta_administrativa || altaData.comentario_alta_administrativa.trim().length < 10) {
        toast.error('Informe o comentário para concluir a alta administrativa. (mínimo 10 caracteres)');
        return;
      }
    }
    // If has active comodato, show comodato step
    if (activeComodatos.length > 0) {
      setComodatoRecolhidos({});
      setAltaStep('comodato');
    } else {
      handleDarAlta();
    }
  };

  const handleDarAlta = async () => {
    try {
      const payload = {
        data_alta: altaData.data_alta,
        motivo_alta: altaData.motivo_alta,
      };
      if (altaData.motivo_alta === 'alta_administrativa') {
        payload.comentario_alta_administrativa = altaData.comentario_alta_administrativa.trim();
      }
      await api.post(`/internacoes/${internacaoId}/alta`, payload);
      toast.success('Alta registrada com sucesso!');
      setAltaStep('form');
      navigate('/kanban');
    } catch (error) {
      const msg = error?.response?.data?.detail || 'Erro ao registrar alta';
      toast.error(msg);
    }
  };

  const handleReverterAlta = async () => {
    if (!reversaoJustificativa || reversaoJustificativa.trim().length < 10) {
      toast.error('Justificativa obrigatória (mínimo 10 caracteres)');
      return;
    }
    setSavingReversao(true);
    try {
      await api.post(`/internacoes/${internacaoId}/reverter-alta`, {
        justificativa: reversaoJustificativa.trim(),
        status_retorno: 'ativo_estavel'
      });
      toast.success('Alta revertida com sucesso! Internação reativada.');
      setShowReversaoAlta(false);
      setReversaoJustificativa('');
      // Reload data
      window.location.reload();
    } catch (error) {
      const msg = error?.response?.data?.detail || 'Erro ao reverter alta';
      toast.error(msg);
    } finally {
      setSavingReversao(false);
    }
  };

  const handleStartEdit = () => {
    setIsEditing(true);
    setEditPaciente({ ...paciente });
    setEditInternacao({ ...internacao });
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditPaciente(null);
    setEditInternacao(null);
    searchParams.delete('edit');
    setSearchParams(searchParams);
  };

  const handleSaveEdit = async () => {
    setSaving(true);
    try {
      // Update patient
      const patientUpdate = {
        nome: editPaciente.nome,
        cpf: paciente.cpf, // Keep original
        data_nascimento: editPaciente.data_nascimento,
        telefone: editPaciente.telefone,
        email: editPaciente.email,
        cep: editPaciente.cep,
        logradouro: editPaciente.logradouro,
        numero: editPaciente.numero,
        complemento: editPaciente.complemento,
        bairro: editPaciente.bairro,
        cidade: editPaciente.cidade,
        uf: editPaciente.uf,
        observacoes: editPaciente.observacoes
      };
      await api.put(`/pacientes/${pacienteId}`, patientUpdate);
      
      // Update internacao
      const internacaoUpdate = {
        paciente_id: editInternacao.paciente_id,
        data_internacao: editInternacao.data_internacao,
        diagnostico_principal: editInternacao.diagnostico_principal,
        cid: editInternacao.cid,
        status_kanban: editInternacao.status_kanban,
        origem: editInternacao.origem,
        origem_grupo: editInternacao.origem_grupo,
        origem_subgrupo: editInternacao.origem_subgrupo,
        medico_responsavel_id: editInternacao.medico_responsavel_id,
        medico_id: editInternacao.medico_id,
        medico_solicitante_id: editInternacao.medico_solicitante_id,
        especialidades: editInternacao.especialidades || [],
        profissionais_especialidades: editInternacao.profissionais_especialidades || {},
        previsao_alta: editInternacao.previsao_alta,
        observacoes: editInternacao.observacoes
      };
      await api.put(`/internacoes/${internacaoId}`, internacaoUpdate);
      
      // Refresh data
      await fetchData();
      setIsEditing(false);
      searchParams.delete('edit');
      setSearchParams(searchParams);
      toast.success('Dados salvos com sucesso!');
    } catch (error) {
      console.error('Error saving:', error);
      toast.error('Erro ao salvar alterações');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </Layout>
    );
  }

  const alertLevel = getDaysAlertLevel(internacao?.dias_internacao || 0);
  const tarefasVencidas = tarefas.filter(t => 
    t.status !== 'concluida' && t.status !== 'cancelada' && 
    new Date(t.data_prevista) < new Date()
  ).length;
  
  // Tarefas de hoje
  const today = todayLocal();
  const tarefasHoje = tarefas.filter(t => 
    t.status !== 'concluida' && t.status !== 'cancelada' && 
    t.data_prevista?.split('T')[0] === today
  ).length;
  
  // Consumo functions
  const resetConsumoForm = () => {
    setConsumoForm({
      item_id: '',
      frequencia: '1x ao dia',
      quantidade_por_aplicacao: '1',
      data_inicio: todayLocal(),
      data_fim: '',
      observacoes: '',
      tipo_uso: 'programado'
    });
    setEditingConsumo(null);
  };
  
  const handleAddConsumo = async () => {
    try {
      const payload = {
        internacao_id: internacaoId,
        item_id: consumoForm.item_id,
        frequencia: consumoForm.frequencia,
        quantidade_por_aplicacao: parseFloat(consumoForm.quantidade_por_aplicacao) || 1,
        data_inicio: consumoForm.data_inicio,
        data_fim: consumoForm.data_fim || null,
        observacoes: consumoForm.observacoes || null,
        tipo_uso: consumoForm.tipo_uso || 'programado'
      };
      
      if (editingConsumo) {
        await api.put(`/estoque/consumo/regras/${editingConsumo.id}`, {
          frequencia: payload.frequencia,
          quantidade_por_aplicacao: payload.quantidade_por_aplicacao,
          data_fim: payload.data_fim,
          observacoes: payload.observacoes,
          tipo_uso: payload.tipo_uso
        });
        toast.success('Regra de consumo atualizada');
      } else {
        await api.post('/estoque/consumo/regras', payload);
        toast.success('Regra de consumo adicionada');
      }
      
      setShowConsumoModal(false);
      resetConsumoForm();
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao salvar regra de consumo');
    }
  };
  
  const handleEditConsumo = (regra) => {
    setEditingConsumo(regra);
    setConsumoForm({
      item_id: regra.item_id,
      frequencia: regra.frequencia || '1x ao dia',
      quantidade_por_aplicacao: regra.quantidade_por_aplicacao?.toString() || '1',
      data_inicio: regra.data_inicio,
      data_fim: regra.data_fim || '',
      observacoes: regra.observacoes || '',
      tipo_uso: regra.tipo_uso || 'programado'
    });
    setShowConsumoModal(true);
  };
  
  const handlePauseConsumo = async (regraId, currentStatus) => {
    try {
      const newStatus = currentStatus === 'pausado' ? 'ativo' : 'pausado';
      await api.put(`/estoque/consumo/regras/${regraId}`, { status: newStatus });
      toast.success(newStatus === 'pausado' ? 'Consumo pausado' : 'Consumo reativado');
      fetchData();
    } catch (error) {
      toast.error('Erro ao alterar status');
    }
  };
  
  const handleEndConsumo = async (regraId) => {
    if (!confirm('Tem certeza que deseja encerrar esta regra de consumo?')) return;
    try {
      await api.delete(`/estoque/consumo/regras/${regraId}`);
      toast.success('Regra de consumo encerrada');
      fetchData();
    } catch (error) {
      toast.error('Erro ao encerrar regra');
    }
  };

  // Comodato functions
  const handleAddComodato = async () => {
    try {
      if (!comodatoForm.comodato_item_id) {
        toast.error('Selecione um item');
        return;
      }
      if (comodatoForm.quantidade_em_uso < 1) {
        toast.error('Quantidade deve ser pelo menos 1');
        return;
      }
      const res = await api.post('/comodato/alocacoes', {
        internacao_id: internacaoId,
        comodato_item_id: comodatoForm.comodato_item_id,
        quantidade_em_uso: comodatoForm.quantidade_em_uso,
        observacoes: comodatoForm.observacoes || ''
      });
      toast.success('Item de comodato adicionado');
      setComodatoAlocacoes(prev => [...prev, res.data]);
      setShowComodatoModal(false);
      setComodatoForm({ comodato_item_id: '', quantidade_em_uso: 1, observacoes: '' });
      // Refresh items to update availability
      api.get('/comodato/itens?ativo=true').then(r => setComodatoItens(r.data)).catch(() => {});
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao adicionar comodato');
    }
  };

  const handleRemoveComodato = async (alocacaoId) => {
    if (!confirm('Encerrar esta alocação de comodato?')) return;
    try {
      await api.put(`/comodato/alocacoes/${alocacaoId}/encerrar`);
      toast.success('Alocação encerrada');
      setComodatoAlocacoes(prev => prev.filter(a => a.id !== alocacaoId));
      api.get('/comodato/itens?ativo=true').then(r => setComodatoItens(r.data)).catch(() => {});
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao encerrar alocação');
    }
  };

  const handleUpdateComodatoQtd = async (alocacaoId, novaQtd) => {
    try {
      const res = await api.put(`/comodato/alocacoes/${alocacaoId}`, { quantidade_em_uso: novaQtd });
      toast.success('Quantidade atualizada');
      setComodatoAlocacoes(prev => prev.map(a => a.id === alocacaoId ? res.data : a));
      api.get('/comodato/itens?ativo=true').then(r => setComodatoItens(r.data)).catch(() => {});
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao atualizar quantidade');
    }
  };

  // Serviços functions
  const resetServicoForm = () => {
    setServicoForm({
      servico_id: '',
      profissional: '',
      recorrente: true,
      frequencia_dias: 1,
      quantidade_por_ocorrencia: 1,
      data_inicio: todayLocal(),
      data_realizacao: todayLocal(),
      data_fim: '',
      observacoes: ''
    });
    setEditingServico(null);
  };

  const handleAddServico = async () => {
    try {
      if (!servicoForm.servico_id) {
        toast.error('Selecione um serviço');
        return;
      }

      // Para serviços únicos, usa data_realizacao como data_inicio
      const dataInicio = servicoForm.recorrente 
        ? servicoForm.data_inicio 
        : (servicoForm.data_realizacao || servicoForm.data_inicio);

      const payload = {
        internacao_id: internacaoId,
        servico_id: servicoForm.servico_id,
        profissional: servicoForm.profissional || null,
        recorrente: servicoForm.recorrente,
        frequencia_dias: servicoForm.recorrente ? parseInt(servicoForm.frequencia_dias) || 1 : 0,
        quantidade_por_ocorrencia: parseInt(servicoForm.quantidade_por_ocorrencia) || 1,
        data_inicio: dataInicio,
        data_realizacao: servicoForm.recorrente ? null : dataInicio,
        data_fim: servicoForm.recorrente ? (servicoForm.data_fim || null) : dataInicio,
        observacoes: servicoForm.observacoes || null
      };

      if (editingServico) {
        await api.put(`/servicos/paciente/${editingServico.id}`, {
          profissional: payload.profissional,
          recorrente: payload.recorrente,
          frequencia_dias: payload.frequencia_dias,
          quantidade_por_ocorrencia: payload.quantidade_por_ocorrencia,
          data_realizacao: payload.data_realizacao,
          data_fim: payload.data_fim,
          observacoes: payload.observacoes
        });
        toast.success('Serviço atualizado');
      } else {
        await api.post('/servicos/paciente', payload);
        toast.success('Serviço adicionado ao paciente');
      }

      setShowServicoModal(false);
      resetServicoForm();
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao salvar serviço');
    }
  };

  const handleEditServico = (servico) => {
    setEditingServico(servico);
    setServicoForm({
      servico_id: servico.servico_id,
      profissional: servico.profissional || '',
      recorrente: servico.recorrente !== false,
      frequencia_dias: servico.frequencia_dias?.toString() || '1',
      quantidade_por_ocorrencia: servico.quantidade_por_ocorrencia?.toString() || '1',
      data_inicio: servico.data_inicio,
      data_realizacao: servico.data_realizacao || servico.data_inicio,
      data_fim: servico.data_fim || '',
      observacoes: servico.observacoes || ''
    });
    setShowServicoModal(true);
  };

  const handlePauseServico = async (servicoId, currentStatus) => {
    try {
      const newStatus = currentStatus === 'pausado' ? 'ativo' : 'pausado';
      await api.put(`/servicos/paciente/${servicoId}`, { status: newStatus });
      toast.success(newStatus === 'pausado' ? 'Serviço pausado' : 'Serviço reativado');
      fetchData();
    } catch (error) {
      toast.error('Erro ao alterar status do serviço');
    }
  };

  const handleEndServico = async (servicoId) => {
    if (!confirm('Tem certeza que deseja encerrar este serviço?')) return;
    try {
      await api.delete(`/servicos/paciente/${servicoId}`);
      toast.success('Serviço encerrado');
      fetchData();
    } catch (error) {
      toast.error('Erro ao encerrar serviço');
    }
  };

  // Prescrição IA functions
  const handleImportPrescricao = async () => {
    if (!prescricaoFile) {
      toast.error('Selecione um arquivo');
      return;
    }

    try {
      setPrescricaoLoading(true);
      const formData = new FormData();
      formData.append('file', prescricaoFile);
      formData.append('internacao_id', internacaoId);

      const response = await api.post('/prescricao/importar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setPrescricaoResult(response.data);
      
      // Auto-select all found items
      const foundIds = response.data.itens_encontrados
        .filter(i => i.item_id_match)
        .map(i => i.item_id_match);
      setSelectedPrescricaoItens(foundIds);
      
      toast.success(`${response.data.resumo.total_itens} itens encontrados na prescrição`);
    } catch (error) {
      console.error('Erro ao importar prescrição:', error);
      toast.error(error.response?.data?.detail || 'Erro ao processar prescrição');
    } finally {
      setPrescricaoLoading(false);
    }
  };

  const handleCreateRegrasPrescricao = async () => {
    if (selectedPrescricaoItens.length === 0) {
      toast.error('Selecione ao menos um item');
      return;
    }

    try {
      setPrescricaoLoading(true);
      
      const itensToCreate = prescricaoResult.itens_encontrados.filter(
        i => selectedPrescricaoItens.includes(i.item_id_match)
      );

      const response = await api.post('/prescricao/criar-regras', {
        internacao_id: internacaoId,
        itens: itensToCreate
      });

      toast.success(`${response.data.regras_criadas} regras de consumo criadas!`);
      setShowPrescricaoModal(false);
      setPrescricaoFile(null);
      setPrescricaoResult(null);
      setSelectedPrescricaoItens([]);
      fetchData();
    } catch (error) {
      toast.error('Erro ao criar regras de consumo');
    } finally {
      setPrescricaoLoading(false);
    }
  };

  const togglePrescricaoItem = (itemId) => {
    setSelectedPrescricaoItens(prev =>
      prev.includes(itemId)
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="perfil-internacao-page">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex items-center gap-4">
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={() => navigate(-1)}
              data-testid="btn-voltar"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-3xl font-bold font-['Manrope'] tracking-tight">
                {paciente?.nome}
              </h1>
              <div className="flex items-center gap-2 mt-1">
                {internacao?.numero_prontuario && <Badge variant="outline" className="font-mono" title="Número do prontuário desta internação" data-testid="badge-prontuario">Prontuário {internacao.numero_prontuario}</Badge>}
                <Badge className={STATUS_COLORS[internacao?.status_kanban]}>
                  {STATUS_LABELS[internacao?.status_kanban]}
                </Badge>
                {(internacao?.origem_grupo || internacao?.origem) && (
                  <Badge className={getOrigemColor(internacao?.origem_grupo, internacao?.origem_subgrupo)}>
                    {internacao?.origem_grupo ? formatOrigem(internacao.origem_grupo, internacao.origem_subgrupo) : (ORIGEM_LABELS[internacao.origem] || internacao.origem)}
                  </Badge>
                )}
                <span className="text-muted-foreground">•</span>
                <span className="text-muted-foreground" data-testid="perfil-cpf">
                  CPF: {displayCPF(paciente?.cpf, canViewFullCPF)}
                </span>
                {internacao?.equipe_nome && (
                  <>
                    <span className="text-muted-foreground">•</span>
                    <Badge variant="outline" data-testid="perfil-equipe-atual">
                      Equipe atual: {internacao.equipe_nome}
                    </Badge>
                  </>
                )}
                {!internacao?.equipe_nome && (
                  <>
                    <span className="text-muted-foreground">•</span>
                    <span className="text-muted-foreground text-sm" data-testid="perfil-equipe-atual">
                      Equipe atual: Não definida
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
          
          <div className="flex gap-2">
            {isEditing ? (
              <>
                <Button 
                  variant="outline" 
                  onClick={handleCancelEdit}
                  className="gap-2"
                  data-testid="btn-cancelar-edicao"
                >
                  <X className="h-4 w-4" />
                  Cancelar
                </Button>
                <Button 
                  onClick={handleSaveEdit}
                  disabled={saving}
                  className="gap-2"
                  data-testid="btn-salvar-edicao"
                >
                  {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
                  Salvar Alterações
                </Button>
              </>
            ) : (
              <>
                <Button 
                  variant="outline" 
                  onClick={handleStartEdit}
                  className="gap-2"
                  data-testid="btn-editar"
                >
                  <Pencil className="h-4 w-4" />
                  Editar
                </Button>
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button variant="outline" className="gap-2" data-testid="btn-dar-alta">
                      <LogOut className="h-4 w-4" />
                      Dar Alta
                    </Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent className="max-w-lg">
                    <AlertDialogHeader>
                      <AlertDialogTitle>
                        {altaStep === 'comodato' ? 'Recolhimento de Comodato' : 'Registrar Alta'}
                      </AlertDialogTitle>
                      <AlertDialogDescription>
                        {altaStep === 'comodato' 
                          ? 'Confirme o recolhimento de todos os itens em comodato antes de finalizar a alta.'
                          : 'Esta ação irá encerrar a internação. Preencha os dados da alta.'
                        }
                      </AlertDialogDescription>
                    </AlertDialogHeader>

                    {altaStep === 'form' ? (
                      <>
                    <div className="space-y-4 py-4">
                      <div className="space-y-2">
                        <Label>Data da Alta</Label>
                        <Input
                          type="date"
                          value={altaData.data_alta}
                          onChange={(e) => setAltaData({...altaData, data_alta: e.target.value})}
                          data-testid="input-data-alta"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Motivo da Alta</Label>
                        <Select 
                          value={altaData.motivo_alta}
                          onValueChange={(v) => setAltaData({...altaData, motivo_alta: v, comentario_alta_administrativa: ''})}
                        >
                          <SelectTrigger data-testid="select-motivo-alta">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            {Object.entries(ALTA_MOTIVO_LABELS).map(([value, label]) => (
                              <SelectItem key={value} value={value}>{label}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      {altaData.motivo_alta === 'alta_administrativa' && (
                        <div className="space-y-2 border-l-4 border-amber-500 pl-4 bg-amber-50 dark:bg-amber-950/20 rounded-r-md p-3">
                          <Label className="font-semibold text-amber-700 dark:text-amber-400">
                            Justificativa da alta administrativa *
                          </Label>
                          <Textarea
                            value={altaData.comentario_alta_administrativa}
                            onChange={(e) => setAltaData({...altaData, comentario_alta_administrativa: e.target.value})}
                            placeholder="Descreva o motivo da alta administrativa..."
                            rows={4}
                            className="resize-none"
                            data-testid="textarea-comentario-alta-administrativa"
                          />
                          {altaData.comentario_alta_administrativa.length > 0 && altaData.comentario_alta_administrativa.trim().length < 10 && (
                            <p className="text-xs text-red-500" data-testid="error-comentario-alta">
                              Informe o comentário para concluir a alta administrativa. (mínimo 10 caracteres)
                            </p>
                          )}
                          <p className="text-xs text-muted-foreground">
                            {altaData.comentario_alta_administrativa.trim().length}/10 caracteres mínimos
                          </p>
                        </div>
                      )}
                      {activeComodatos.length > 0 && (
                        <div className="flex items-center gap-2 text-sm bg-amber-50 dark:bg-amber-950/20 border border-amber-300 rounded-md px-3 py-2">
                          <PackageCheck className="h-4 w-4 text-amber-600 shrink-0" />
                          <span className="text-amber-700 dark:text-amber-400">
                            <strong>{activeComodatos.length}</strong> item(ns) em comodato — será necessário confirmar o recolhimento.
                          </span>
                        </div>
                      )}
                    </div>
                    <AlertDialogFooter>
                      <AlertDialogCancel onClick={() => setAltaStep('form')}>Cancelar</AlertDialogCancel>
                      <AlertDialogAction 
                        onClick={(e) => { e.preventDefault(); handleAltaNext(); }}
                        data-testid="btn-avancar-alta"
                        disabled={altaData.motivo_alta === 'alta_administrativa' && altaData.comentario_alta_administrativa.trim().length < 10}
                      >
                        {activeComodatos.length > 0 ? 'Avançar →' : 'Confirmar Alta'}
                      </AlertDialogAction>
                    </AlertDialogFooter>
                      </>
                    ) : (
                      <>
                    <div className="space-y-3 py-4 max-h-[50vh] overflow-y-auto">
                      <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-300 rounded-lg p-3">
                        <p className="text-sm font-semibold text-amber-700 dark:text-amber-400 flex items-center gap-2 mb-3">
                          <PackageCheck className="h-4 w-4" />
                          Alta suspensa — confirme o recolhimento dos itens
                        </p>
                        <div className="space-y-2">
                          {activeComodatos.map((aloc) => (
                            <div 
                              key={aloc.id} 
                              className={`flex items-center justify-between p-3 rounded-md border cursor-pointer transition-all ${
                                comodatoRecolhidos[aloc.id]
                                  ? 'bg-green-50 border-green-300 dark:bg-green-950/20'
                                  : 'bg-white border-amber-200 dark:bg-gray-900 animate-pulse'
                              }`}
                              onClick={() => setComodatoRecolhidos(prev => ({ ...prev, [aloc.id]: !prev[aloc.id] }))}
                              data-testid={`comodato-recolher-${aloc.id}`}
                            >
                              <div className="flex items-center gap-3">
                                {comodatoRecolhidos[aloc.id] ? (
                                  <CircleCheck className="h-5 w-5 text-green-600 shrink-0" />
                                ) : (
                                  <Circle className="h-5 w-5 text-amber-400 shrink-0" />
                                )}
                                <div>
                                  <p className="font-medium text-sm">{aloc.comodato_item_nome || aloc.item_nome || 'Item'}</p>
                                  <p className="text-xs text-muted-foreground">
                                    Qtd em uso: {aloc.quantidade_em_uso || 1}
                                    {aloc.observacoes ? ` — ${aloc.observacoes}` : ''}
                                  </p>
                                </div>
                              </div>
                              <Badge variant="outline" className={comodatoRecolhidos[aloc.id] ? 'border-green-500 text-green-700' : 'border-amber-400 text-amber-600'}>
                                {comodatoRecolhidos[aloc.id] ? 'Recolhido' : 'Pendente'}
                              </Badge>
                            </div>
                          ))}
                        </div>
                      </div>
                      <p className="text-xs text-muted-foreground text-center">
                        {allComodatosRecolhidos 
                          ? '✓ Todos os itens confirmados. Pode finalizar a alta.' 
                          : `Faltam ${activeComodatos.length - Object.values(comodatoRecolhidos).filter(Boolean).length} item(ns) para confirmar.`
                        }
                      </p>
                    </div>
                    <AlertDialogFooter>
                      <AlertDialogCancel onClick={() => setAltaStep('form')}>← Voltar</AlertDialogCancel>
                      <AlertDialogAction 
                        onClick={(e) => { e.preventDefault(); handleDarAlta(); }}
                        data-testid="btn-confirmar-alta"
                        disabled={!allComodatosRecolhidos}
                        className={!allComodatosRecolhidos ? 'opacity-50' : ''}
                      >
                        Confirmar Alta
                      </AlertDialogAction>
                    </AlertDialogFooter>
                      </>
                    )}
                  </AlertDialogContent>
                </AlertDialog>
                {internacao?.status_kanban === 'alta_efetivada' && (isAdmin || ['medico'].includes(user?.perfil)) && (
                  <Button 
                    variant="outline" 
                    className="gap-2 border-green-400 text-green-700 hover:bg-green-50"
                    onClick={() => { setShowReversaoAlta(true); setReversaoJustificativa(''); }}
                    data-testid="btn-reverter-alta"
                  >
                    <RotateCcw className="h-4 w-4" />
                    Reverter Alta
                  </Button>
                )}
              </>
            )}
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Card>
            <CardContent className="p-4 flex items-center gap-4">
              <div className="p-3 rounded-lg bg-blue-100 dark:bg-blue-900/30">
                <Calendar className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Data Internação</p>
                <p className="font-semibold">{formatDate(internacao?.data_internacao)}</p>
              </div>
            </CardContent>
          </Card>

          <Card className={alertLevel !== 'normal' ? 'border-l-4 border-l-' + (alertLevel === 'critical' ? 'red' : 'yellow') + '-500' : ''}>
            <CardContent className="p-4 flex items-center gap-4">
              <div className={`p-3 rounded-lg ${
                alertLevel === 'critical' ? 'bg-red-100 dark:bg-red-900/30' :
                alertLevel === 'warning' ? 'bg-yellow-100 dark:bg-yellow-900/30' :
                'bg-green-100 dark:bg-green-900/30'
              }`}>
                <Clock className={`h-5 w-5 ${
                  alertLevel === 'critical' ? 'text-red-600 dark:text-red-400' :
                  alertLevel === 'warning' ? 'text-yellow-600 dark:text-yellow-400' :
                  'text-green-600 dark:text-green-400'
                }`} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Tempo Internado</p>
                <p className="font-semibold font-mono">D+{internacao?.dias_internacao}</p>
              </div>
            </CardContent>
          </Card>

          <Card 
            className={`cursor-pointer hover:shadow-md transition-shadow ${tarefasHoje > 0 ? 'border-l-4 border-l-blue-500' : ''}`}
            onClick={() => {
              setTarefaFilter('hoje');
              setActiveTab('tarefas');
            }}
            data-testid="card-tarefas-hoje"
          >
            <CardContent className="p-4 flex items-center gap-4">
              <div className={`p-3 rounded-lg ${
                tarefasHoje > 0 ? 'bg-blue-100 dark:bg-blue-900/30' : 'bg-gray-100 dark:bg-gray-900/30'
              }`}>
                <ClipboardList className={`h-5 w-5 ${
                  tarefasHoje > 0 ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'
                }`} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Tarefas de Hoje</p>
                <p className="font-semibold">{tarefasHoje}</p>
              </div>
            </CardContent>
          </Card>

          <Card 
            className={`cursor-pointer hover:shadow-md transition-shadow ${tarefasVencidas > 0 ? 'border-l-4 border-l-red-500' : ''}`}
            onClick={() => {
              setTarefaFilter('vencidas');
              setActiveTab('tarefas');
            }}
            data-testid="card-tarefas-vencidas"
          >
            <CardContent className="p-4 flex items-center gap-4">
              <div className={`p-3 rounded-lg ${
                tarefasVencidas > 0 ? 'bg-red-100 dark:bg-red-900/30' : 'bg-gray-100 dark:bg-gray-900/30'
              }`}>
                <AlertTriangle className={`h-5 w-5 ${
                  tarefasVencidas > 0 ? 'text-red-600 dark:text-red-400' : 'text-gray-600 dark:text-gray-400'
                }`} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Tarefas Vencidas</p>
                <p className={`font-semibold ${tarefasVencidas > 0 ? 'text-red-600' : ''}`}>{tarefasVencidas}</p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList>
            <TabsTrigger value="internacao" data-testid="tab-internacao">Internação</TabsTrigger>
            <TabsTrigger value="planejamento" data-testid="tab-planejamento">Planejamento</TabsTrigger>
            <TabsTrigger value="tarefas" data-testid="tab-tarefas">
              Tarefas
              {tarefas.filter(t => t.status !== 'concluida' && t.status !== 'cancelada').length > 0 && (
                <Badge variant="secondary" className="ml-2">
                  {tarefas.filter(t => t.status !== 'concluida' && t.status !== 'cancelada').length}
                </Badge>
              )}
            </TabsTrigger>
            <TabsTrigger value="consumo" data-testid="tab-consumo">
              <Package className="h-4 w-4 mr-1" />
              Consumo
              {consumoRegras.filter(r => r.status === 'ativo').length > 0 && (
                <Badge variant="secondary" className="ml-2">
                  {consumoRegras.filter(r => r.status === 'ativo').length}
                </Badge>
              )}
            </TabsTrigger>
            <TabsTrigger value="comodato" data-testid="tab-comodato">
              <Package className="h-4 w-4 mr-1" />
              Comodato
              {comodatoAlocacoes.length > 0 && (
                <Badge variant="secondary" className="ml-2">
                  {comodatoAlocacoes.length}
                </Badge>
              )}
            </TabsTrigger>
            <TabsTrigger value="servicos" data-testid="tab-servicos">
              <Briefcase className="h-4 w-4 mr-1" />
              Serviços
              {servicosPaciente.filter(s => s.status === 'ativo').length > 0 && (
                <Badge variant="secondary" className="ml-2">
                  {servicosPaciente.filter(s => s.status === 'ativo').length}
                </Badge>
              )}
            </TabsTrigger>
            <TabsTrigger 
              value="prescricao" 
              data-testid="tab-prescricao"
              onClick={() => navigate(`/prescricao?internacao=${internacaoId}`)}
            >
              <Stethoscope className="h-4 w-4 mr-1" />
              Prescrição
            </TabsTrigger>
            <TabsTrigger value="financeiro" data-testid="tab-financeiro">
              <DollarSign className="h-4 w-4 mr-1" />
              Financeiro
            </TabsTrigger>
          </TabsList>

          {/* Internação Tab */}
          <TabInternacao
            isEditing={isEditing}
            canEditPatient={canEditPatient}
            canViewFullCPF={canViewFullCPF}
            paciente={paciente}
            internacao={internacao}
            editPaciente={editPaciente}
            setEditPaciente={setEditPaciente}
            editInternacao={editInternacao}
            setEditInternacao={setEditInternacao}
            medicos={medicos}
            historicoEquipe={historicoEquipe}
            historicoMedico={historicoMedico}
            api={api}
          />
          {activeTab === 'internacao' && !isEditing && paciente?.id && <HistoricoProntuarios pacienteId={paciente.id} internacaoAtualId={internacao?.id} />}

          {/* Planejamento Tab */}
          <TabPlanejamento
            planejamento={planejamento}
            setPlanejamento={setPlanejamento}
            saving={saving}
            handleSavePlanejamento={handleSavePlanejamento}
          />

          {/* Tarefas Tab */}
          <TabTarefas
            tarefas={tarefas}
            tarefaFilter={tarefaFilter}
            setTarefaFilter={setTarefaFilter}
            tarefaModalOpen={tarefaModalOpen}
            setTarefaModalOpen={setTarefaModalOpen}
            novaTarefa={novaTarefa}
            setNovaTarefa={setNovaTarefa}
            usuarios={usuarios}
            tarefasHoje={tarefasHoje}
            tarefasVencidas={tarefasVencidas}
            handleCreateTarefa={handleCreateTarefa}
            handleUpdateTarefaStatus={handleUpdateTarefaStatus}
            handleDeleteTarefa={handleDeleteTarefa}
            fetchData={fetchData}
          />
          
          {/* Consumo Tab */}
          <TabConsumo
            consumoRegras={consumoRegras}
            estoqueItens={estoqueItens}
            showConsumoModal={showConsumoModal}
            setShowConsumoModal={setShowConsumoModal}
            editingConsumo={editingConsumo}
            consumoForm={consumoForm}
            setConsumoForm={setConsumoForm}
            handleAddConsumo={handleAddConsumo}
            handleEditConsumo={handleEditConsumo}
            handlePauseConsumo={handlePauseConsumo}
            handleEndConsumo={handleEndConsumo}
            resetConsumoForm={resetConsumoForm}
            showPrescricaoModal={showPrescricaoModal}
            setShowPrescricaoModal={setShowPrescricaoModal}
            prescricaoFile={prescricaoFile}
            setPrescricaoFile={setPrescricaoFile}
            prescricaoResult={prescricaoResult}
            setPrescricaoResult={setPrescricaoResult}
            prescricaoLoading={prescricaoLoading}
            selectedPrescricaoItens={selectedPrescricaoItens}
            setSelectedPrescricaoItens={setSelectedPrescricaoItens}
            handleImportPrescricao={handleImportPrescricao}
            handleCreateRegrasPrescricao={handleCreateRegrasPrescricao}
            togglePrescricaoItem={togglePrescricaoItem}
          />

          {/* Comodato Tab */}
          <TabComodato
            comodatoAlocacoes={comodatoAlocacoes}
            comodatoItens={comodatoItens}
            internacao={internacao}
            showComodatoModal={showComodatoModal}
            setShowComodatoModal={setShowComodatoModal}
            comodatoForm={comodatoForm}
            setComodatoForm={setComodatoForm}
            handleAddComodato={handleAddComodato}
            handleRemoveComodato={handleRemoveComodato}
            handleUpdateComodatoQtd={handleUpdateComodatoQtd}
          />

          {/* Serviços Tab */}
          <TabServicos
            servicosPaciente={servicosPaciente}
            servicosCatalogo={servicosCatalogo}
            resumoCustos={resumoCustos}
            resumoPeriodo={resumoPeriodo}
            setResumoPeriodo={setResumoPeriodo}
            loadingResumo={loadingResumo}
            canViewServiceRevenue={canViewServiceRevenue}
            canViewServicePayout={canViewServicePayout}
            canViewStockCosts={canViewStockCosts}
            showServicoModal={showServicoModal}
            setShowServicoModal={setShowServicoModal}
            editingServico={editingServico}
            servicoForm={servicoForm}
            setServicoForm={setServicoForm}
            handleAddServico={handleAddServico}
            handleEditServico={handleEditServico}
            handlePauseServico={handlePauseServico}
            handleEndServico={handleEndServico}
            resetServicoForm={resetServicoForm}
          />

          {/* Financeiro Tab */}
          <TabFinanceiro 
            financeiroData={financeiroData}
            loadingFinanceiro={loadingFinanceiro}
            canViewServiceRevenue={canViewServiceRevenue}
            canViewServicePayout={canViewServicePayout}
            canViewStockCosts={canViewStockCosts}
            isAdmin={isAdmin}
          />
        </Tabs>
      </div>

      {/* Reversão de Alta Modal */}
      <Dialog open={showReversaoAlta} onOpenChange={setShowReversaoAlta}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-green-700">
              <RotateCcw className="h-5 w-5" />
              Reverter Alta
            </DialogTitle>
            <DialogDescription>
              Esta ação irá cancelar a alta e reativar a internação. Informe a justificativa.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="space-y-2">
              <Label className="font-semibold">Justificativa da reversão *</Label>
              <Textarea
                value={reversaoJustificativa}
                onChange={(e) => setReversaoJustificativa(e.target.value)}
                placeholder="Descreva o motivo da reversão da alta..."
                rows={4}
                className="resize-none"
                data-testid="textarea-reversao-justificativa"
              />
              {reversaoJustificativa.length > 0 && reversaoJustificativa.trim().length < 10 && (
                <p className="text-xs text-red-500">Mínimo 10 caracteres</p>
              )}
              <p className="text-xs text-muted-foreground">
                {reversaoJustificativa.trim().length}/10 caracteres mínimos
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowReversaoAlta(false)}>
              Cancelar
            </Button>
            <Button
              onClick={handleReverterAlta}
              disabled={savingReversao || reversaoJustificativa.trim().length < 10}
              className="bg-green-600 hover:bg-green-700"
              data-testid="btn-confirmar-reversao"
            >
              {savingReversao ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Confirmar reversão
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Layout>
  );
};

export default PerfilInternacao;
